import React, { Component } from 'react'

import Modal from './Modal'

import Backend from '../../../utils/Backend'
export default class DeleteFilterModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
      filter: props.filter,
      categoryId: props.categoryId,
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  _deleteFilter() {
    let { filter } = this.state
    Backend.deleteFilter(filter)
      .then((category) => {
        this.props.onDeleted()
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  render() {
    let { filter } = this.state
    if (!filter) {
      return null
    }
    return (
      <Modal
        className=""
        show={this.state.show}
        onHide={() => {
          this.props.onHide()
        }}
      >
        <div>
          <div className="title fs-2">Remove Filter</div>
          <div>
            <span>Are you sure you would like to remove this filter?</span>
          </div>
          <div className="mt-3">
            <button
              type="button"
              className="btn btn-warning me-2"
              onClick={() => this._deleteFilter()}
            >
              Remove
            </button>
            <button
              type="button"
              className="btn btn-light"
              onClick={() => this.props.onHide()}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}
